import React from 'react';
import classnames from 'classnames';
import { compose } from 'redux';
import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { initGallectionStream, initGallectionDeviationStream, } from '../../actions';
import { withTranslation } from 'react-i18next';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import withSearch from '../../_hocs/withSearch';
import withCurrentMediaSource from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import s from './Breadcrumbs.scss';
var enhance = compose(withCurrentMediaSource, withCurrentGallection, withCurrentSubfolder, withSearch, withTranslation(), connectMediaStore(null, {
    initGallectionStream: initGallectionStream,
    initGallectionDeviationStream: initGallectionDeviationStream,
}));
export var Breadcrumbs = function (_a) {
    var currentMediaSource = _a.currentMediaSource, currentGallection = _a.currentGallection, unsetCurrentFolderId = _a.unsetCurrentFolderId, currentSubfolder = _a.currentSubfolder, unsetCurrentSubfolderId = _a.unsetCurrentSubfolderId, searchQuery = _a.searchQuery, initGallectionStreamAction = _a.initGallectionStream, initGallectionDeviationStreamAction = _a.initGallectionDeviationStream, t = _a.t;
    if (currentMediaSource === MediaSourceType.CUSTOM_SET) {
        return null;
    }
    var crumbs = [];
    if (currentMediaSource === MediaSourceType.BROWSE) {
        crumbs.push({
            node: t(searchQuery ? 'mediapopup.search.searchResults' : 'mediapopup.browse'),
        });
    }
    else {
        crumbs.push({
            node: t('mediapopup.allFolders'),
            onClick: function () {
                unsetCurrentFolderId();
                unsetCurrentSubfolderId();
                initGallectionStreamAction();
            },
        });
        if (currentGallection) {
            crumbs.push({
                node: currentGallection.name,
                onClick: function () {
                    unsetCurrentSubfolderId();
                    initGallectionDeviationStreamAction();
                },
            });
        }
        if (searchQuery) {
            crumbs.push({
                node: searchQuery,
            });
        }
        if (currentSubfolder) {
            crumbs.push({
                node: currentSubfolder.name,
            });
        }
    }
    return (React.createElement("div", { className: s['root'] }, crumbs.map(function (crumb, index) { return (React.createElement("span", { key: index, className: classnames(s['crumb'], index === crumbs.length - 1 && s['active']), onClick: crumb.onClick }, crumb.node)); })));
};
Breadcrumbs.displayName = 'Breadcrumbs';
export default enhance(Breadcrumbs);
//# sourceMappingURL=Breadcrumbs.connected.js.map